import { useCallback, useRef } from 'react';

// Kept in its own module so the React Compiler treats `isPageMounted` as an opaque import: read
// from the same file as the context value it would otherwise be inlined into, it flags the ref
// access as possibly happening during render (see RuleExtractionTrackingProvider.tsx).
export const useRuleExtractionPageMountedTracking = () => {
  const pageMountedRef = useRef(false);

  const notifyPageMounted = useCallback((mounted: boolean) => {
    pageMountedRef.current = mounted;
  }, []);

  const isPageMounted = useCallback(() => pageMountedRef.current, []);

  return { notifyPageMounted, isPageMounted };
};
